export const interfaceOptions = [
  { label: "Chatbot", value: "chatbot" },
  { label: "Form", value: "form" },
];

export const methodOptions = [
  { label: "Phone", value: "phone" },
  { label: "Email", value: "email" },
];



// WEBPACK FOOTER //
// ./src/screens/Brand/constants.js